import * as React from 'react';
import * as ReactDOM from 'react-dom';
import TopicPageSearch from './top-page-search';
import { PageModel } from './models';



const mount = document.getElementById('topic-page');
const settings = (window as any)?.bootstrap?.topicPageSettings as PageModel;
if (mount) {

	ReactDOM.render(
		<TopicPageSearch pageModel={settings} />
		, mount,
	);
}